module.exports = "<holidays-page></holidays-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/holidays.html
// module id = 1761
// module chunks = 0